/**
 * The neal.fun attribution, in one place.
 *
 * It appears twice — as the header of the arcade section on /games, and as a
 * footer on each individual game page — and those two must never drift apart.
 * Both read from here.
 *
 * What we owe Neal Agarwal is the *ideas*: every game in the arcade is our own
 * implementation (our rules, dilemmas, catalogue, recipe tree) with no code, text
 * or assets taken from neal.fun. Game mechanics are not copyrightable, so this
 * credit is courtesy rather than obligation — but foregrounding that a person
 * thought of these first is the whole point, so it is not optional here.
 */
export const NEAL_URL = 'https://neal.fun';
export const NEAL_NAME = 'Neal Agarwal';

/** Why the credit exists, in the arcade section header. */
export const CREDIT_LEAD =
  'Every game below is our own take on something Neal Agarwal thought of first.';

/** The part that matters: these ideas were human work. */
export const CREDIT_HUMAN =
  'He designed and hand-wrote the originals — the ideas, the jokes, the pacing, the reason any of this is fun at all. That was human work, and no amount of AI would have invented it. Ours were rebuilt here with AI assistance, which is the easy part once somebody else has done the imagining.';

export const CREDIT_GO_PLAY = 'If you enjoy these, the originals are better.';

export const CREDIT_DISCLAIMER =
  'Not affiliated with, endorsed by, or copied from neal.fun.';
